import { memo } from 'react';

import { FileStatusIconProgressing, FileStatusTitle } from '@air/feature-file-status/ui';

import { getTaskPaneFileStatusIconSize } from '~/components/FileStatusTrackingPane/getTaskPaneFileStatusIconSize';
import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';
import { TaskPaneDismissButton } from '~/components/FileStatusTrackingPane/TaskPaneDismissButton';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';
import { type CTWTask, type GetInProgressMetadata } from '~/store/tasks/types';

export type CopyToWorkspacePanelInProgressPanelItemProps = {
  metadata: Pick<GetInProgressMetadata<CTWTask>, 'targetWorkspaceName'>;
  onCancel: () => void;
};

export const CopyToWorkspacePanelInProgressPanelItem = memo(
  ({ onCancel, metadata: { targetWorkspaceName } }: CopyToWorkspacePanelInProgressPanelItemProps) => {
    const { ui2026 } = useTemporaryFeatureFlags();
    const title = ui2026 ? `Copying to ${targetWorkspaceName}` : `Saving to "${targetWorkspaceName}"`;

    return (
      <PaneItemTW
        avatar={<FileStatusIconProgressing size={getTaskPaneFileStatusIconSize(ui2026)} />}
        title={<FileStatusTitle>{ui2026 ? `${title}…` : title}</FileStatusTitle>}
        buttons={<TaskPaneDismissButton label="Cancel" onClick={onCancel} />}
      />
    );
  },
);

CopyToWorkspacePanelInProgressPanelItem.displayName = 'CopyToWorkspacePanelInProgressPanelItem';
